// src/config/passportConfig.js
// Feature flags for Member Passport system

export const PASSPORT_CONFIG = {
    // Core features (always enabled)
    enabled: true,
    showStamps: true,
    showTiers: true,
    showHeaderDisplay: true,
    showProgress: true,
    showAnimations: true,
    
    // Advanced features (turned off initially)
    showStreaks: true,        // 🚫 Hide streak tracking
    showAchievements: false,   // 🚫 Hide achievement system
    showCityCount: true,      // 🚫 Hide city exploration for now
    showTierBenefits: false,   // 🚫 Hide detailed tier benefits

    showYearlyProgress: true,
    showYearlyComparison: true,
    showYearlyLeaderboard: true,
    
    // Analytics (admin only)
    enableAnalytics: true,
    
    // Tier configuration (simplified)
    origtiers: {
      'new': { 
        name: 'Connect Tier', 
        icon: '🤝', 
        stamps: 0,
        color: 'gray'
      },
      'bronze': { 
        name: 'Community Member', 
        icon: '🥉', 
        stamps: 3,
        color: 'amber'
      },
      'silver': { 
        name: 'Trusted Member', 
        icon: '🥈', 
        stamps: 5,
        color: 'gray'
      },
      'gold': { 
        name: 'Community Champion', 
        icon: '🥇', 
        stamps: 15,
        color: 'yellow'
      },
      'platinum': {
        name: 'Community Catalyst',
        icon: '🌟',
        stamps: 30,
        color: 'purple'
      }
    },

    // NEW (2026 thresholds)
    tiers: {
       'new': { 
        name: 'Connect Tier', 
        icon: '🤝', 
        stamps: 0,
        color: 'gray'
      },
      'bronze': { name: 'Community Member', icon: '🥉', stamps: 5, color: 'amber' },    // 3 → 5
      'silver': { name: 'Trusted Member', icon: '🥈', stamps: 12, color: 'gray' },      // 5 → 12
      'gold': { name: 'Community Champion', icon: '🥇', stamps: 30, color: 'yellow' },  // 15 → 30
      'platinum': { name: 'Community Catalyst', icon: '🌟', stamps: 60, color: 'purple' } // 30 → 60
    }


  };
  
  // Helper function to check if a feature is enabled
  export const isFeatureEnabled = (featureName) => {
    return PASSPORT_CONFIG[featureName] === true;
  };
  
  // Get tier configuration
  export const getTierConfig = (tier) => {
    return PASSPORT_CONFIG.tiers[tier] || PASSPORT_CONFIG.tiers['new'];
  };
  
  export const getQRDisplayConfig = () => {
    return {
      showStamps: PASSPORT_CONFIG.showStamps,
      showTiers: PASSPORT_CONFIG.showTiers,
      showProgress: PASSPORT_CONFIG.showProgress,
      showAnimations: PASSPORT_CONFIG.showAnimations,
      showStreaks: PASSPORT_CONFIG.showStreaks,
      showAchievements: PASSPORT_CONFIG.showAchievements,
      showCityCount: PASSPORT_CONFIG.showCityCount
    };
  };